<template>
  <div class="c-scroll-up">
    <div class="c-scroll-up__button" :class="{'-active': active}" @click="onClick">
      <icon name="chevron-up"></icon>
    </div>
  </div>
</template>

<script>

import Icon from "../element/icon.vue";

export default {
  components: {
    "icon": Icon
  },
  data (){
    return {
      active: false,
      threshold: 100
    }
  },
  mounted (){
    $(document).on("scroll", this.onScroll);
  },
  methods: {
    onScroll (e){
      let top = $(e.target).scrollTop();
      this.active = top > this.threshold;
    },
    onClick (){
      $("html, body").animate({
        scrollTop: 0
      }, 300);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/component/scroll-up.vue